<template>
  <div class="validation-result">
    <a-alert
      :type="alertType"
      :message="alertMessage"
      :description="alertDescription"
      show-icon
    >
      <template #icon>
        <CheckCircleOutlined v-if="result.is_valid && result.warnings.length === 0" />
        <CloseCircleOutlined v-else-if="!result.is_valid" />
        <WarningOutlined v-else />
      </template>
    </a-alert>

    <div v-if="result.errors && result.errors.length > 0" style="margin-top: 16px">
      <a-typography-title :level="5">错误列表</a-typography-title>
      <a-list size="small" :data-source="result.errors">
        <template #renderItem="{ item }">
          <a-list-item style="color: #ff4d4f">
            {{ item }}
          </a-list-item>
        </template>
      </a-list>
    </div>

    <div v-if="result.warnings && result.warnings.length > 0" style="margin-top: 16px">
      <a-typography-title :level="5">警告列表</a-typography-title>
      <a-list size="small" :data-source="result.warnings">
        <template #renderItem="{ item }">
          <a-list-item style="color: #faad14">
            {{ item }}
          </a-list-item>
        </template>
      </a-list>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { CheckCircleOutlined, CloseCircleOutlined, WarningOutlined } from '@ant-design/icons-vue';

export default {
  name: 'ValidationResult',
  components: {
    CheckCircleOutlined,
    CloseCircleOutlined,
    WarningOutlined
  },
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const alertType = computed(() => {
      if (props.result.is_valid && props.result.warnings.length === 0) {
        return 'success';
      } else if (!props.result.is_valid) {
        return 'error';
      } else {
        return 'warning';
      }
    });

    const alertMessage = computed(() => {
      if (props.result.is_valid && props.result.warnings.length === 0) {
        return '验证通过';
      } else if (!props.result.is_valid) {
        return '验证不通过';
      } else {
        return '验证通过，但有警告';
      }
    });

    const alertDescription = computed(() => {
      if (props.result.is_valid && props.result.warnings.length === 0) {
        return '响应格式完全符合出参定义';
      } else if (!props.result.is_valid) {
        return `发现 ${props.result.errors?.length || 0} 个错误`;
      } else {
        return `发现 ${props.result.warnings?.length || 0} 个警告`;
      }
    });

    return {
      alertType,
      alertMessage,
      alertDescription
    };
  }
};
</script>

<style scoped>
.validation-result {
  margin-bottom: 16px;
}
</style>

